import { render, staticRenderFns } from "./IconSvgSHMemorial.vue?vue&type=template&id=33d06062&scoped=true&"
import script from "./IconSvgSHMemorial.vue?vue&type=script&lang=js&"
export * from "./IconSvgSHMemorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d06062",
  null
  
)

export default component.exports